<template>
  <div>
    <v-card class="mx-auto" :loading="loading" max-width="600">
      <v-card-text>
        <v-autocomplete
          v-model="active_fitting_id"
          :items="fittings"
          :filter="combinedSearch"
          item-value="fitting_id"
          label="Fitting"
          :loading="fittings.length == 0"
          @change="changeRoute"
        >
          <template v-slot:selection="{ item }">
            {{ getShipName(item.ship_type_id) }}, {{ item.name }}
          </template>
          <template v-slot:item="{ item }">
            <template v-if="typeof item !== 'object'">
              <v-list-item-content v-text="item" />
            </template>
            <template v-else>
              <v-list-item-avatar tile>
                <img :src="shipUrl(item.ship_type_id)" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.name" />
                <v-list-item-subtitle v-text="getShipName(item.ship_type_id)" />
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="loadedCharacter" @click="loadFittings">Refresh fittings</v-btn>
        <p v-else>Please <a :href="login_url">login</a> to access your fittings.</p>
      </v-card-actions>
    </v-card>
    <fitting-card v-if="fitting_id" :fitting_id="fitting_id" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import FittingCard from "@/components/FittingCard";

export default {
  name: "Fittings",
  components: { FittingCard },
  props: {
    fitting_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      active_fitting_id: null
    };
  },
  computed: {
    ...mapState({
      loadedCharacter: state => !!state.character_id,
      login_url: "login_url",
      fittings: state => {
        const groups = state.ship_groups;
        const grouped_fittings = [];
        const order = [
          237, 25, 831, 324, 834, 830, 893, 1527, 420, 541, 1534, 1305, 26,
          1972, 906, 833, 358, 894, 832, 963, 419, 1201, 540, 27, 898, 900,
          485, 1538, 547, 659, 30, 31, 28, 1202, 380, 513, 902, 1283, 463,
          543, 941, 883, 1022
        ];
        order.forEach(group_id => {
          const group = groups.find(x => x.group_id == group_id);
          grouped_fittings.push({ header: group.name });
          state.fittings
            .filter(x => group.types.includes(x.ship_type_id))
            .sort((a, b) => {
              if (a.ship_type_id == b.ship_type_id) {
                return a.name > b.name ? 1 : -1;
              }
              return a.ship_type_id > b.ship_type_id ? 1 : -1;
            })
            .forEach(x => grouped_fittings.push(x));
          grouped_fittings.push({ divider: true });
        });
        return grouped_fittings;
      },
      ships: "ships",
      types: state => Object.fromEntries(state.types.map(x => [x.type_id, x]))
    })
  },
  methods: {
    loadFittings() {
      this.loading = true;
      this.$store.dispatch("loadFittings").then(() => (this.loading = false));
    },
    changeRoute() {
      this.$router.push({
        name: "Fittings",
        params: { fitting_id: this.active_fitting_id }
      });
    },
    getShipName(ship_id) {
      return this.ships.find(x => x.type_id == ship_id).name;
    },
    shipUrl(ship_id) {
      return `https://images.evetech.net/types/${ship_id}/icon`;
    },
    combinedSearch(item, query) {
      if (item.header || item.divider) return;
      const search = query.toLowerCase();
      const fit_name = item.name.toLowerCase();
      const ship_name = this.getShipName(item.ship_type_id).toLowerCase();
      return fit_name.indexOf(search) > -1 || ship_name.indexOf(search) > -1;
    }
  }
};
</script>
